import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage, injectIntl } from 'react-intl'
import Button from '@vtex/styleguide/lib/Button'

import { intlShape } from '@/checkout-instore-legacy/i18n/intlShape'
import Price from '@/checkout-instore-legacy/components/Commons/Price'
import { formatSimpleDate } from '@/checkout-instore-legacy/utils/DateUtils'
import Items from '../Items'
import { convertChosenSkuProductsToItems } from '../../../utils'
import Box from '../../../../components/Commons/Elements/Box'

class LastOrder extends PureComponent {
  handleCopyOrder = () =>
    this.props.onAddToCart && this.props.onAddToCart(this.props.order.products)

  render() {
    const { order, intl } = this.props

    const { orderId } = order

    const numberOfProducts = order.products && order.products.length

    const products =
      numberOfProducts > 0 ? order.products.slice().reverse() : []

    return (
      <Box className="mb2 mb3-l">
        <div className="c-on-base">
          <div className="flex justify-between t-heading-5">
            {orderId}
            <div className="b">
              <Price value={order.totalValue} intl={intl} />
            </div>
          </div>
          <div className="flex justify-between mt4 c-muted-2 t-small">
            {formatSimpleDate(new Date(order.creationDate))}
            <FormattedMessage
              id={`orderStatus.${order.status.toLowerCase()}`}
            />
          </div>
        </div>
        <div className="nh5 mv6">
          <Items items={convertChosenSkuProductsToItems(products)} />
        </div>
        <Button variation="secondary" onClick={this.handleCopyOrder}>
          <FormattedMessage id="customerProfileCopyOrder" />
        </Button>
      </Box>
    )
  }
}

LastOrder.defaultProps = {
  showBorder: true,
}

LastOrder.propTypes = {
  order: PropTypes.object.isRequired,
  showBorder: PropTypes.bool,
  onManageOrder: PropTypes.func.isRequired,
  onAddToCart: PropTypes.func.isRequired,
  mediaQuery: PropTypes.func,
  intl: intlShape,
}

export default injectIntl(LastOrder)
